module.exports = __webpack_public_path__ + "static/media/Genesis-Mobile-Banner-@2-822x186.0a22b913.jpg";